import vfukColors from '@vfuk/core-theme-ws2/dist/constants/colors';

const colors = {
  mineShaft: '#333333',
  ...vfukColors,
};

export default colors;
